const state = {
  isLoading:false,
  selectedBar:'',
  showFlowNotice:false,
}

const mutations = {
  TOGGLE_IS_LOADING(state,isLoading){
    state.isLoading = isLoading
  },
  SET_SELECTEDBAR(state,name){
    state.selectedBar = name
  },
  SET_FLOWNOTICE(state,val){
    state.showFlowNotice = val
  },
}

const actions = {
  toggleIsLoading({ commit },isLoading){
    commit('TOGGLE_IS_LOADING',isLoading)
  },
  setSelectedBar({ commit },name){
    commit('SET_SELECTEDBAR',name)
  },
  setFlowNotice({ commit },val){
    commit('SET_FLOWNOTICE',val)
  },
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/globalData.js